import { render, staticRenderFns } from "./DashboardsBIBC.vue?vue&type=template&id=2a773b70&scoped=true"
import script from "./DashboardsBIBC.vue?vue&type=script&lang=js"
export * from "./DashboardsBIBC.vue?vue&type=script&lang=js"
import style0 from "./DashboardsBIBC.vue?vue&type=style&index=0&id=2a773b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a773b70",
  null
  
)

export default component.exports